"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SizeAndRatio = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M2,4.99508929 L2,19.0049107 C2,19.5552764 2.44394026,20 2.991155,20 L21.008845,20 C21.5568386,20 22,19.555686 22,19.0049107 L22,4.99508929 C22,4.44472363 21.5560597,4 21.008845,4 L2.991155,4 C2.44316143,4 2,4.44431397 2,4.99508929 Z M1,4.99508929 C1,3.8932319 1.88967395,3 2.991155,3 L21.008845,3 C22.1085295,3 23,3.8926228 23,4.99508929 L23,19.0049107 C23,20.1067681 22.1103261,21 21.008845,21 L2.991155,21 C1.89147046,21 1,20.1073772 1,19.0049107 L1,4.99508929 Z M6,8 L6,12 L5,12 L5,7 L10,7 L10,8 L6,8 Z M19,12 L19,17 L14,17 L14,16 L18,16 L18,12 L19,12 Z" })));
};
SizeAndRatio.displayName = 'SizeAndRatio';
exports.default = SizeAndRatio;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SizeAndRatio.js.map